<div *ngIf="isEventsLoading || isEventNodesLoading" class="shell-state-wrapper loading-state">
    <div class="loading-spinner"></div>
</div>

<div *ngIf="!isEventsLoading && !isEventNodesLoading && events.length === 0" class="shell-state-wrapper empty-state">
    <div class="empty-state-header">
        <button id="buttonDRPL-empty" class="showDLR-button" density="compact" label="Compact Button"
                variant="secondary" shape="round" color-variant="default" data-qaa="buttonDRPL-empty"
                (click)="openSidebar()">
            {{ 'DISPATCH_LIST.SHOW_LIST' | translate }}
        </button>
    </div>
    <div class="empty-state-content">
        <mat-icon class="empty-state-icon">help</mat-icon>
        <h2 class="empty-state-title">{{ 'DISPATCH_PERFORMANCE.EMPTY_STATE.TITLE' | translate }}</h2>
        <p class="empty-state-subtitle">{{ 'DISPATCH_PERFORMANCE.EMPTY_STATE.SUBTITLE' | translate }}</p>
    </div>
</div>

<app-chart
    *ngIf="!isEventsLoading && !isEventNodesLoading && events.length > 0"
    (sidebarOpenRequested)="openSidebar()"
></app-chart>
<app-sidebar
    [isOpen]="isSidebarOpen"
    (close)="closeSidebar()"
    [eventNode]="eventNode"
    [events]="events"
></app-sidebar>

<div *ngIf="!isEventsLoading && !isEventNodesLoading" class="mobile-sidebar-toggle">
    <button class="mobile-sidebar-toggle__button" (click)="openSidebar()">
        {{ 'DISPATCH_LIST.SHOW_LIST' | translate }}
    </button>
</div>
